/**
 * FutureBeacon.ts — THE CENTRAL STRUCTURE. PROTECT THIS. (§3.2, §6)
 * Cannot be built; exists at game start. Houses Nigel. Emits Signal Strength.
 * If destroyed, the game is lost.
 */

import { Building } from '../entities/Building';
import { Faction } from '../types';
import { BEACON_STARTING_SIGNAL, BEACON_MAX_SIGNAL } from '../constants';

export class FutureBeacon extends Building {
  signalStrength = BEACON_STARTING_SIGNAL;
  readonly maxSignal = BEACON_MAX_SIGNAL;

  constructor() {
    super();
    this.faction = Faction.Player;
    this.constructed = true;
  }

  update(delta: number): void {
    // TODO: signal recalculated by BeaconSystem; render signal ring + jeopardy state.
  }
}
